import coerceId from '../system/coerce-id';
import isNonEmptyString from './is-non-empty-string';
export default function constructResource(type, id, lid) {
  var trueId = coerceId(id);
  if (!isNonEmptyString(trueId)) {
    if (isNonEmptyString(lid)) {
      return {
        type,
        id: trueId,
        lid
      };
    }
    throw new Error(`Expected either id or lid to be a valid string`);
  }
  if (isNonEmptyString(lid)) {
    return {
      type,
      id: trueId,
      lid
    };
  }
  return {
    type,
    id: trueId
  };
}